module.exports = __webpack_public_path__ + "img/SEL1625G.c44ad90c.jpg";